import Aanbieders from '../assets/img/portfolio/aanbieders.png'
import Crerax from '../assets/img/portfolio/crerax.png'
import Linum from '../assets/img/portfolio/linum.png'
import Ntaskmanager from '../assets/img/portfolio/ntaskmanager.png'
import Odyssey from '../assets/img/portfolio/odyssey.png'
import Theheadhunters360 from '../assets/img/portfolio/theheadhunters360.png'
import Altron from '../assets/img/portfolio/altron.png'

export const portfolioItems = [
  {
    id: 1,
    link: "https://aanbieders.be/",
    image: Aanbieders,
    category: "Web App Development",
    title: "Aanbieders (Telecom Providers)",
  },
  {
    id: 2,
    link: "https://crerax.com/",
    image: Crerax,
    category: "Website Development",
    title: "Crerax",
  },
  {
    id: 3,
    link: "http://linumtech.com/",
    image: Linum,
    category: "Web Development",
    title: "Linum Technologies LLC",
  },
  {
    id: 4,
    link: "https://ntaskmanager.com/",
    image: Ntaskmanager,
    category: "Website Development",
    title: "nTask Manager",
  },
  {
    id: 5,
    link: "https://odysseyinc.com/",
    image: Odyssey,
    category: "Website Development",
    title: "Odyssey Computing",
  },
  {
    id: 6,
    link: "https://theheadhunters360.com/",
    image: Theheadhunters360,
    category: "Website Development",
    title: "The Head Hunters 360 (HR Agency)",
  },
  {
    id: 7,
    link: "https://healthone-dev-identity.altronhealthtech.com/Identity/Account/Login",
    image: Altron,
    category: "Web App Development",
    title: "Altron HealthTech",
  },
];